import { motion } from "framer-motion";
import { Crown } from "lucide-react";
import { HouseDialog } from "@/components/site/HouseDialog";

export const SuccessDialog = ({ b, go }) => {
  const s = b.success;
  return (
    <HouseDialog open={!!s} onOpenChange={(o) => !o && b.setSuccess(null)} title="Request received, boo! 💜"
      testId="booking-success-dialog">
      {s ? (
        <div className="success">
          <motion.div className="success-crown" initial={{ scale: 0, rotate: -25 }} animate={{ scale: 1, rotate: 0 }}
            transition={{ type: "spring", stiffness: 220, damping: 14 }}>
            <Crown strokeWidth={1.3} />
          </motion.div>
          <p className="success-script">Your throne is reserved, {s.name.split(" ")[0]}</p>
          <dl className="success-list" data-testid="booking-success-summary">
            <dt>Service</dt><dd>{s.service}</dd>
            <dt>When</dt><dd>{s.dateLabel} at {s.time_label}</dd>
            <dt>Where</dt><dd>{s.appt_type}</dd>
          </dl>
          <p className="notice">Smiless will review your request and confirm within 24 hours. Your $15 deposit is due after approval.</p>
          <div className="flex flex-wrap gap-3 mt-4">
            <button type="button" className="cta" onClick={() => b.setSuccess(null)} data-testid="booking-success-close">Done</button>
            <button type="button" className="cta ghost" onClick={() => { b.setSuccess(null); go("gallery"); }}
              data-testid="booking-success-gallery">See the Crown Gallery</button>
          </div>
        </div>
      ) : null}
    </HouseDialog>
  );
};
